import { IAuthenticationService } from "../../../domain/document";
import { AuthenticatedService } from "../..";

export class AuthenticationService extends AuthenticatedService implements IAuthenticationService {
  constructor(getToken: () => string) {
    super(getToken);
  }

  async authenticateWizard(userId: string, password: string): Promise<void> {
    await this.post(
      "/api/document/wizard/authenticate",
      {
        password,
      });
  }

  async authenticateWizardManagement(password: string): Promise<void> {
    await this.post(
      "/api/document/wizard/authenticate/management",
      {
        password,
      });
  }
}
